document.addEventListener('DOMContentLoaded', function () {

    if (typeof wp !== 'undefined' && wp.domReady) {
        wp.domReady(function () {
            setTimeout(function () {
                openCourseModal()
            }, 800); // Delay after the DOM is ready
        });
    } else {
        openCourseModal()
    }

    function openCourseModal() {

        const loaderWrapper = document.querySelector('.loader-wrapper');

        const openModalButtons = document.querySelectorAll('.open-course-modal');
        const modal = document.querySelector('.course-modal');
        const modalBlock = modal.querySelector('.course-modal__block');
        const modalContent = modal.querySelector('.modal-content');

        const closeModalBtn = modal.querySelector('.close-course-modal-btn')
        const html = document.querySelector('html')

        async function getCourseDescription(id){
            const postData = async (url, data) => {
                const res = await fetch(url, {
                    method: 'POST',
                    body: data,
                });

                if (!res.ok) {
                    const errorText = await res.text();
                    throw new Error(errorText);
                }

                return await res.json();
            }

            const formData = new FormData();
            formData.append('action', 'getCourseDescription');
            formData.append('id', id);


            try {
                const res = await postData(themeUrl.ajax_url, formData);

                if (res.success) {
                    modalContent.innerHTML = res.data.content;
                    modal.classList.add('show');
                    loaderWrapper.classList.remove('show');
                } else {
                    console.log(res);
                }
            } catch (err) {
                console.error(err);
            }


        }
        async function openModal(courseID) {
            loaderWrapper.classList.add('show');
            html.classList.add('modal-is-opened');
            await getCourseDescription(courseID);


        }

        function closeModal(){
            modal.classList.remove('show');
            html.classList.remove('modal-is-opened');
        }

        openModalButtons.forEach(btn => {
            const courseID = btn.dataset.id;
            btn.addEventListener('click', function () {
                openModal(courseID);
            });

        });

        closeModalBtn.addEventListener('click', closeModal);

        // Close modal when clicking outside the modal block
        modal.addEventListener('click', function (e) {
            if (!modalBlock.contains(e.target)) {
                closeModal();
            }
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                closeModal();
            }
        });



    }

    });